import styled, { createGlobalStyle } from "styled-components";
import { MDBBtn, MDBContainer, MDBCol, MDBRow, MDBCard, MDBDropdownToggle, MDBTabs, MDBTabsContent } from "mdb-react-ui-kit";

export const GlobalStyle = createGlobalStyle`
  ${({ theme }) => `
  body {
    background-color: #F8F9FF;
  }

  a {
    color: ${theme.primaryColor};
  }

  .modal-title {
    font-size: 1.25rem;
  }

  .dropdown-menu {
    z-index: 1100 !important;
  }

  ${theme.breakpoints.up('lg')} {
    .form-outline .form-control~.form-label.no-ellipsis {
      max-width: none;
    }
  }

  ${theme.breakpoints.up('sm')} {
    .MuiAutocomplete-listbox .MuiAutocomplete-option {
      min-height: 36px;
    }
  }

  .nubs__body .btn:focus {
    outline: 2px solid ${theme.accent2Color};
  }

  .fr-popup.fr-active {
    z-index: 1061!important;
  }
  `}
`;

export const Container = styled(MDBContainer)`
  ${({ theme }) => `
    margin-top: ${theme.headerPadding};
    padding-left: 24px;
    padding-right: 24px;
    max-width: 100vw;

    ${theme.breakpoints.up('sm')} {
      max-width: 96vw;
    }

    ${theme.breakpoints.up('md')} {
      max-width: calc(100vw - 245px);
    }
  `}
`;

export const Col = styled(MDBCol)`
  display: flex;
  align-items: center;

  &.col-2:not(.justify-start) {
    justify-content: flex-end;
  }

  &.col--align-start {
    align-items: flex-start;
  }

  &.col--no-grow {
    flex-grow: 0;
  }

  &.col--grow {
    flex-grow: 1;
  }

  &.col--stretch {
    > * {
      margin: 0;

      &.row {
        margin-top: calc(var(--mdb-gutter-y)*-1);
        margin-right: calc(var(--mdb-gutter-x)/-2);
        margin-left: calc(var(--mdb-gutter-x)/-2);
      }
    }
  }

  &.col--row-wrapper {
    > * {
      margin-top: calc(var(--mdb-gutter-y) * -1);
      margin-right: calc(var(--mdb-gutter-x) / -2);
      margin-left: calc(var(--mdb-gutter-x) / -2);
    }
  }

  > * {
    margin: 0 0.5rem 0 0;

    &.row {
      margin-top: calc(var(--mdb-gutter-y)*-1);
      margin-right: calc(var(--mdb-gutter-x)/-2);
      margin-left: calc(var(--mdb-gutter-x)/-2);
    }
  }

  button {
    margin-bottom: 0;
  }

  *:not(.form-clean) {
    > textarea.form-control,
    > select.form-control {
      border: solid #bdbdbd;
      border-width: 0 0 1px 0;
      border-radius: 0;
      padding-top: 1.5rem;

      & + .form-label {
        margin-left: -0.75rem;
      }
    }
  }

  .form-outline,
  textarea {
    width: 100%;
  }

  .form-outline .form-control:focus ~ .form-label {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const Row = styled(MDBRow)`
  .card-body & + & .form-outline,
  .tab-content & + & .form-outline {
    margin-top: 2rem;

    @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
      margin-top: 3rem;
    }
  }

  .card-body &:last-child .form-outline {
    margin-bottom: 2rem;

    @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
      margin-bottom: 3rem;
    }
  }

  .card-body &:last-child .form-outline {
    margin-bottom: 2rem;

    @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
      margin-bottom: 3rem;
    }
  }

  .card-body [class*="radio__item__body"] .form-outline {
    margin-bottom: 0;

    @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
      margin-bottom: 0;
    }
  }
`;

export const NavRow = styled(Row)`
  ${({ theme }) => `
    & {
      flex-grow: 1;
      flex-wrap: nowrap;
      display: none;

      ${theme.breakpoints.up('sm')} {
        display: flex;
      }
    }

    &,
    > * {
      --mdb-gutter-x: 0;
    }
  `}
`;

export const NavCol = styled(MDBCol)`
    &.nav-wrapper {
      flex-grow: 0;
    }
`;

export const MobileNav = styled.div`
  ${({ theme }) => `
    ${theme.breakpoints.up('sm')} {
      display: none;
    }
  `}
`;

export const HeaderRow = styled(Row)`
  margin-bottom: 1.625rem;

  .col-search__wrapper {
    flex-grow: 1;
  }
`;

export const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  button {
    margin: 1rem 0.3125rem;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 3rem;
  text-align: right;
`;

function expandHex(hex) {
  const raw = String(hex).replace('#', '').trim()
  const full = raw.length === 3 ? raw.split('').map((char) => `${char}${char}`).join('') : raw
  return full.slice(0, 6)
}

function channel(hex, offset) {
  const value = parseInt(expandHex(hex).slice(offset, offset + 2), 16) / 255
  return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
}

function contrastRatio(background, foreground) {
  const luminance = (hex) => (
    (0.2126 * channel(hex, 0))
    + (0.7152 * channel(hex, 2))
    + (0.0722 * channel(hex, 4))
  )
  const lighter = Math.max(luminance(background), luminance(foreground))
  const darker = Math.min(luminance(background), luminance(foreground))
  return (lighter + 0.05) / (darker + 0.05)
}

// White on Social Scavenger warning orange (#FF961B) is about 2.18:1.
// That is the lightest warning fill that already ships with white text.
// Birthday yellow is below this, so the label switches to a darker theme color.
const WARNING_WHITE_TEXT_FLOOR = 2

function warningTextColor(theme) {
  const white = theme.white || '#FFFFFF'
  if (contrastRatio(theme.warningColor, white) >= WARNING_WHITE_TEXT_FLOOR) {
    return ''
  }
  const readable = [theme.primaryColor, theme.darkColor, theme.black || '#000000']
    .find((color) => color && contrastRatio(theme.warningColor, color) >= 4.5)
  return readable || theme.primaryColor
}

const flatBtnStyle = ({ theme }) => {
  const warningLabel = warningTextColor(theme)
  return `
  position: relative;
  font-size: 0.875rem;
  margin-bottom: 0.3125rem;
  text-decoration: none;
  letter-spacing: 0;
  outline: 0;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  line-height: 1.5;
  white-space: nowrap;
  text-transform: none;
  border-radius: ${theme.rounded.sm};

  &:not(.btn-light) {
    box-shadow: none;
  }

  &.btn--flat {
    text-transform: none;
    box-shadow: none;
    border-radius: ${theme.rounded.sm};
  }

  &.btn--wrap {
    white-space: normal;
  }

  &.btn--flat-md {
    border-radius: ${theme.rounded.md};
  }

  &.btn--lowercase {
    text-transform: none;
  }

  a {
    color: white;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &.btn-accent1 {
    background-color: ${theme.accent1Color};
    color: white;
  }

  &.btn-danger {
    background-color: ${theme.dangerColor};
  }

  &.btn-primary {
    background-color: ${theme.primaryColor};
  }

  &.btn-success {
    background-color: ${theme.successColor};
  }

  &.btn-warning {
    background-color: ${theme.warningColor};
    ${warningLabel ? `
      color: ${warningLabel};
      &:hover,
      &:focus,
      &:active {
        color: ${warningLabel};
      }
      a {
        color: ${warningLabel};
      }
    ` : ''}
  }

  &.btn-info {
    background-color: ${theme.infoColor};
  }

  &.btn-link {
    color: ${theme.linkButtonColor};
  }

  &.btn--narrow {
    padding: .625rem;
    min-width: 57.63px;

    ${theme.breakpoints.up('md')} {
      padding: .625rem 1rem .5rem 1rem;
    }
  }

  &.btn-outline-primary {
    color: ${theme.primaryColor};
    border-color: ${theme.primaryColor};
  }

  &.btn-outline-info {
    color: ${theme.infoColor};
    border-color: ${theme.infoColor};
  }

  &:focus {
    outline: 2px solid ${theme.accent2Color};
  }
`
}

export const Button = styled(MDBBtn)`
  ${flatBtnStyle}
`;

export const DropdownToggle = styled(MDBDropdownToggle)`
  ${flatBtnStyle}
`;

export const ActionButtonWrapper = styled.div`
  text-align: right;
  margin: 1rem 0 0;

  ${Button} {
    margin: 0 0.25rem;

    &.btn-light {
      padding-left: 1rem;
      padding-right: 1rem;
      background-color: #eceff1;
      border-color: #eceff1;
    }
  }

  .modal-body {
    text-align: left;
  }
`;

export const ChallengeActionButtonWrapper = styled(MDBRow)`
  ${({ theme }) => `
  text-align: right;
  margin-top: 1rem;

  ${Button} {
    &.btn-light {
      padding-left: 1rem;
      padding-right: 1rem;
      background-color: #eceff1;
      border-color: #eceff1;
    }
  }

  .modal-body {
    text-align: left;
  }

  ${theme.breakpoints.down('sm')} {
    ${Button} {
      flex-grow: 1;
    }
  }
  `}
`;

export const NpcItemActionButtonWrapper = ChallengeActionButtonWrapper
export const DesignationItemActionButtonWrapper = ChallengeActionButtonWrapper

export const Divider = styled.hr`
  border: none;
  border-bottom: 1px dotted #dddddd;
`;

export const TextareaCol = styled(Col)`
  align-items: flex-start;
  flex-direction: column;
`;

export const Card = styled(MDBCard)`
  ${({ theme }) => `
    border-radius: ${theme.rounded.md};
  `}
`;

export const CardBody = styled.div`
  .MuiInput-root {
    width: 100%;
  }
`;

export const HelpText = styled.span`
  ${({ theme, focus }) => `
    color: ${theme.darkGreyColor}90;
    font-size: 0.8rem;
    margin-left: 0;
    position: absolute;
    top: 100%;
    transition: opacity linear 0.25s;
    opacity: ${focus ? "1" : "0"};

    @media (max-width: ${theme.maxMobileWidth}) {
      line-height: 1.2;
    }
  `}
`;

export const DescText = styled.span`
  ${({ theme }) => `
    color: ${theme.darkGreyColor}90;
    font-size: 0.8rem;
    margin-left: 0;

    @media (max-width: ${theme.maxMobileWidth}) {
      line-height: 1.2;
    }
  `}
`;

export const FieldHelpText = styled.span`
  ${({ theme }) => `
    color: ${theme.darkGreyColor}90;
    margin-left: 0;
    font-size: 0.8rem;
    animation: slideIn .5s linear forwards;

    @media (max-width: ${theme.maxMobileWidth}) {
      line-height: 1.2;
    }

    @keyframes slideIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `}
`;

export const AppContainer = styled.div`
`;

export const Tabs = styled(MDBTabs)`
  background-color: #eceff1;

  .nav-link {
    &.active {
      border-color: ${({ theme }) => theme.primaryColor};
      color: ${({ theme }) => theme.primaryColor};
    }
  }

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    .nav-item {
      flex-grow: 1;
    }

    .nav-link {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      text-align: center;
    }
  }
`;

export const TabsContent = styled(MDBTabsContent)`
    margin-bottom: 2.5rem;
`;

export const MapLoading = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 10px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2)
`;

export const RealTimeDot = styled.div`
  ${({ theme, isFetching }) => `
    position: absolute;
    top: calc(.5rem);
    left: calc(1rem + 12px);
    width: 12px;
    height: 12px;
    background-color: ${theme.realTimeDot};
    border: 2px solid ${theme.primaryColor};
    border-radius: 50%;
    animation: ${isFetching ? 'blink .75s infinite' : 'none'};

    .game-summary & {
      left: 12px;
    }
    
    @keyframes blink {
      0%, 50% {
        opacity: 1;
        background-color: ${theme.realTimeDot};
      }
      51%, 100% {
        opacity: 0.75;
        background-color: ${theme.realTimeDot};
      }
    }
  `}
`;